/**
 * The shared-device layer between the session gate and the app shell.
 *
 * On a personal session it is a plain `<Outlet>` — nothing changes. On a
 * kiosk session nobody gets past it without saying who they are, and while
 * they are inside, the idle guard watches for the device being left alone
 * (1 Oct).
 */

import { useEffect } from "react";
import { Outlet } from "react-router";

import { useKiosk } from "@/lib/api";
import { clearKioskPerson, useKioskPerson } from "@/lib/kiosk-person";

import { KioskIdleGuard } from "./kiosk-idle-guard";
import { KioskPersonStep } from "./kiosk-person-step";

export function KioskGate() {
  const kiosk = useKiosk();
  const person = useKioskPerson();

  // A name left over from a kiosk session must never ride along on a personal
  // one (someone signed in as themselves in the same tab).
  useEffect(() => {
    if (kiosk === null && person !== null) {
      clearKioskPerson();
    }
  }, [kiosk, person]);

  if (kiosk === null) {
    return <Outlet />;
  }
  if (person === null) {
    return <KioskPersonStep deviceName={kiosk.device_name} />;
  }
  return (
    <>
      <Outlet />
      <KioskIdleGuard />
    </>
  );
}
